export default {"src":"/stays/_next/static/media/bathrooms.dd1dab49.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};